import React from 'react';
import {ColumnLayout} from '@amzn/awsui-components-react';
import {InputSignal} from '../bulk-override';
import {useAuth} from '../hooks/use-auth';
import {Notification} from '../navigation/page-layout';
import {OteExclusionManager} from '../ote-exclusions';

export function InputSignalsPage(props: {pushNotification: (notification: Notification) => void}) {
    const auth = useAuth();
    const oteAnomalyDetectionEnabled = auth.authInformation!.current!.configurationData?.oteAnomalyDetectionEnabled ?? false;

    // When OTE anomaly detection is enabled, show the exclusion controls beside the percentage
    // adjustment block rather than stacked underneath it.
    if (oteAnomalyDetectionEnabled) {
        return (
            <ColumnLayout columns={2}>
                <InputSignal pushNotification={props.pushNotification} />
                <OteExclusionManager pushNotification={props.pushNotification} />
            </ColumnLayout>
        );
    }

    return <InputSignal pushNotification={props.pushNotification} />;
}
